import type { FC, ReactNode } from "react";
import { useEffect } from "react";

import classnames from "classnames";

import styles from "./PageBaseLayout.module.scss";

type PageBaseLayoutProps = {
  header?: ReactNode;
  content: ReactNode;
  aside?: ReactNode;
  exception?: ReactNode;
} & Omit<React.HTMLAttributes<HTMLDivElement>, "content">;

export const PageBaseLayout: FC<PageBaseLayoutProps> = ({ header, content, aside, exception, ...restProps }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.main} data-testid="page-base-layout-wrapper" {...restProps}>
      {exception}

      <div
        className={classnames(styles.pageLayoutContainer, {
          [styles.orderExceptionVisible]: !!exception,
        })}
      >
        {header}

        <div
          className={classnames(styles.container, {
            [styles.orderExceptionVisible]: !!exception,
            [styles.withAside]: !!aside,
          })}
        >
          <div data-testid="page-base-layout-content">{content}</div>
          {aside && <div data-testid="page-base-layout-aside">{aside}</div>}
        </div>
      </div>
    </div>
  );
};
